import React from 'react';
import { Link } from 'react-router-dom';
import { LocationDescriptor } from 'history';
import { FeatureCard } from '@unmind/design-system';
import { categoryContent_exploreCategory_subCategories as SubCategory } from '../../Category/__generated__/categoryContent';
import { tracking } from '../../../App/Tracking';
import { ContentType } from '../../types';

export interface SubCategoryCardProps {
  category: SubCategory;
  getCategoryTo(slug: string, title: string): LocationDescriptor;
}

const SubCategoryCard = ({ category, getCategoryTo }: SubCategoryCardProps) => {
  const { id, title, summary, slug, internalName } = category;

  const trackCategoryClicked = () => {
    tracking.track('content-selected', {
      contentId: id,
      contentSlug: slug,
      contentDuration: null,
      contentType: ContentType.category,
      source: 'explore-category-subcategory-button',
      contentCategoryPath: internalName,
      isFavourite: null,
    });
  };

  return (
    <FeatureCard
      titleAsChild
      size="small"
      element="article"
      icon={{
        name: 'arrow-right',
        variant: 'icon-small',
      }}
      description={summary ? summary : undefined}
      data-testid="sub-category-card"
    >
      <Link to={getCategoryTo(slug, title)} onClick={trackCategoryClicked}>
        {title}
      </Link>
    </FeatureCard>
  );
};

export default SubCategoryCard;
